module.exports = __webpack_public_path__ + "static/media/pic1.c4dc6d57.png";